import React, { memo } from 'react'

import Text from './Text'
import CustomTooltip from '../customTooltip/CustomTooltip'

const HeadingText = ({ label, isLargeFont, helpText, ...restProps }) => {
  return (
    <CustomTooltip label={helpText}>
      <Text
        variant='h2'
        label={label}
        fontWeight={700}
        component='span'
        {...(isLargeFont && {
          color: '',
          fontWeight: 900,
          sx: {
            fontSize: 46,
            wordWrap: 'break-word'
          }
        })}
        {...restProps}
      />
    </CustomTooltip>
  )
}

export default memo(HeadingText)
